import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { resolvePostLoginRoute } from '@/utils/setupStatus';

export const AuthRedirect: React.FC = () => {
  const { user, loading } = useAuth();
  // Logged-in target is resolved async: admins on an unconfigured workspace
  // are routed to the Customise page instead of the dashboard.
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setTarget('/login');
      return;
    }
    let cancelled = false;
    resolvePostLoginRoute().then((route) => {
      if (!cancelled) setTarget(route);
    });
    return () => { cancelled = true; };
  }, [user, loading]);

  if (loading || !target) {
    return (
      <div className="dark flex items-center justify-center h-screen bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return <Navigate to={target} replace />;
};
